import { render } from "./GanttChartDemo.vue?vue&type=template&id=86772ea6"
import script from "./GanttChartDemo.vue?vue&type=script&lang=js"
export * from "./GanttChartDemo.vue?vue&type=script&lang=js"

import "./GanttChartDemo.vue?vue&type=style&index=0&id=86772ea6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__